const steps = [
  {
    number: "01",
    icon: "ri-inbox-line",
    title: "Input Layer",
    desc: "Capture leads, requests, data, and communications from every channel into one unified system. No more information silos.",
    tags: ["Lead capture", "Form processing", "Email parsing", "API connections"],
    imgSrc: "https://public.readdy.ai/ai/img_res/61ccd12c2c30f239e730311899b17ddb.jpg",
    flip: false,
  },
  {
    number: "02",
    icon: "ri-cpu-line",
    title: "Intelligence Layer",
    desc: "AI processes, routes, and prioritizes workflows based on urgency, context, and your specific business rules—automatically.",
    tags: ["AI routing", "Priority scoring", "Context analysis", "Rule engine"],
    imgSrc: "https://readdy.ai/api/search-image?query=abstract%20AI%20neural%20network%20visualization%20with%20clean%20geometric%20nodes%20and%20connection%20paths%20on%20white%20background%20representing%20intelligent%20processing%20and%20routing%20minimal%20modern%20professional%20digital%20art%20soft%20indigo%20light%20gray%20tones%20systematic%20ordered&width=720&height=480&seq=noveka-sys-intel-1&orientation=landscape",
    flip: true,
  },
  {
    number: "03",
    icon: "ri-send-plane-line",
    title: "Execution Layer",
    desc: "Automations complete tasks, trigger actions, and track outcomes—without manual intervention. Every time.",
    tags: ["Task automation", "Action triggers", "Outcome tracking", "Reporting"],
    imgSrc: "https://readdy.ai/api/search-image?query=abstract%20minimal%20workflow%20completion%20visualization%20showing%20task%20execution%20checkmarks%20outcomes%20arrows%20on%20white%20background%20clean%20organized%20systematic%20professional%20digital%20illustration%20representing%20completed%20actions%20and%20results%20light%20gray%20white%20tones&width=720&height=480&seq=noveka-sys-exec-1&orientation=landscape",
    flip: false,
  },
];

export default function SystemsOverview() {
  return (
    <section
      id="how-it-works"
      className="bg-[#F7F8FA] py-28 px-6 md:px-10"
      style={{ fontFamily: "Inter, sans-serif" }}
    >
      <div className="max-w-6xl mx-auto">
        {/* Heading */}
        <div className="text-center mb-20">
          <p className="text-xs font-medium text-[#4F46E5] uppercase tracking-widest mb-4">
            The System
          </p>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-semibold text-[#1F2933] tracking-[-0.03em] leading-[1.08]">
            How Noveka AI Works
          </h2>
          <p className="text-base text-[#6B7280] mt-5 max-w-xl mx-auto leading-relaxed">
            Three layers working in concert—so your operations run themselves.
          </p>
        </div>

        {/* Split layout steps */}
        <div className="flex flex-col gap-6">
          {steps.map((step) => (
            <div
              key={step.title}
              className={`flex flex-col ${step.flip ? "lg:flex-row-reverse" : "lg:flex-row"} gap-0 rounded-[20px] border border-[#E5E7EB] overflow-hidden bg-white group hover:shadow-[0_8px_40px_rgba(0,0,0,0.07)] transition-all duration-300`}
            >
              {/* Image side */}
              <div className="lg:w-1/2 h-64 lg:h-auto overflow-hidden bg-[#F7F8FA]">
                <img
                  src={step.imgSrc}
                  alt={step.title}
                  className="w-full h-full object-cover object-center group-hover:scale-[1.03] transition-transform duration-500"
                />
              </div>

              {/* Text side */}
              <div className="lg:w-1/2 p-10 lg:p-14 flex flex-col justify-center">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-10 h-10 flex items-center justify-center rounded-[10px] bg-[#EEF2FF] border border-[#C7D2FE]">
                    <i className={`${step.icon} text-lg text-[#4F46E5]`}></i>
                  </div>
                  <span className="text-4xl font-semibold text-[#E5E7EB] leading-none tracking-[-0.04em] select-none">
                    {step.number}
                  </span>
                </div>

                <h3 className="text-2xl md:text-3xl font-semibold text-[#1F2933] tracking-[-0.02em] mb-4">
                  {step.title}
                </h3>
                <p className="text-sm md:text-base text-[#6B7280] leading-relaxed mb-8">{step.desc}</p>

                <div className="flex flex-wrap gap-2">
                  {step.tags.map((tag) => (
                    <span
                      key={tag}
                      className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#F7F8FA] border border-[#E5E7EB] text-xs font-medium text-[#374151]"
                    >
                      <span className="w-1 h-1 rounded-full bg-[#4F46E5]"></span>
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
